import { render, staticRenderFns } from "./ModalCustomerPushHistory.vue?vue&type=template&id=70583516"
import script from "./ModalCustomerPushHistory.vue?vue&type=script&lang=ts"
export * from "./ModalCustomerPushHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports